import * as yup from "yup";

export const YieldCalculatorValidationSchema = yup.object({
    surface: yup
        .number()
        .transform((value) => (Number.isNaN(value) ? 1 : value))
        .positive()
        .required()
});

export type YieldCalculatorFormValues = yup.InferType<
    typeof YieldCalculatorValidationSchema
>;
